import { createStyles, Theme } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

/** Label + value row for checkout shipping rate (matches address row rhythm). */
export const useShipmentRateLabelRowStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      alignItems: 'flex-start',
      width: '100%',
      marginTop: theme.spacing(3),
      [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
        alignItems: 'stretch',
      },
    },
    label: {
      flex: '0 0 88px',
      fontWeight: theme.typography.fontWeightBold as number,
      marginRight: theme.spacing(1),
      marginTop: -1,
      [theme.breakpoints.down('md')]: {
        flex: '0 0 auto',
        marginRight: 0,
        marginBottom: theme.spacing(1),
        marginTop: 0,
      },
    },
    value: {
      flex: 1,
      minWidth: 0,
      display: 'flex',
      alignItems: 'flex-start',
    },
  })
)
